import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const appRoutes: Routes = [
	{
		path: '',
		loadChildren: () => import('./main/main.module').then((m) => m.MainModule)
	},
	{
		path: 'login',
		children: [
			{
				path: '**',
				loadChildren: () =>
					import('./spa-host/spa-host.module').then((m) => m.SpaHostModule),
				data: { app: 'ob-login-web' }
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(appRoutes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}
